/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_Area_ClearInputs */

const cs_requirements_area_clear = /** @type {(inputs: Requirements_Area_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit oblast`)
};

const en_requirements_area_clear = /** @type {(inputs: Requirements_Area_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear area`)
};

/**
* | output |
* | --- |
* | "Clear area" |
*
* @param {Requirements_Area_ClearInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_area_clear = /** @type {((inputs?: Requirements_Area_ClearInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_Area_ClearInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_area_clear(inputs)
	return cs_requirements_area_clear(inputs)
});